<template>
  <Block type="accountSetting" id="login-follow">
    <div class="follow-rule-wrap">
      <p>{{ languages.account_syyjm }}</p>
      <p>{{ languages.account_yjmznsyyc }}</p>
    </div>
    <form>
      <Editor
        v-model="followCode"
        editorClass="editor"
        class="editor-wrapper relative"
        type="passportAccountEditor"
        :placeholder="languages.account_sryjm"
      ></Editor>
      <Editor
        v-model="password"
        editorClass="editor"
        class="editor-wrapper relative"
        type="passportAccountEditor"
        :placeholder="languages.account_srmm"
      ></Editor>
      <label class="submit-wrapper">
        <Button
          type="lightfill"
          class="btn follow-btn"
          data-asyncbtn
          @click="switchByFollowCode"
        >
          {{ languages.login }}
        </Button>
      </label>
    </form>
    <transition name="fade">
      <Dialog v-show="showDialog"></Dialog>
    </transition>
    <PopupWindow
      @onCancel="showPopup = false"
      @onConfirm="showPopup = false"
      type="tips"
      v-if="showPopup"
      :languages="languages"
      :content="errTips"
    ></PopupWindow>
  </Block>
</template>

<script>
import Dialog from '../../components/passport/Dialog';
import { HIDE_DIALOG } from '../../store/dialog';
import { SWTICH_BY_MIGRATE } from '../../store/account';
export default {
  data() {
    return {
      followCode: '',
      password: '',
      showPopup: false,
      errTips: '',
    };
  },

  computed: {
    showDialog() {
      return this.$store.state.dialog.showDialog;
    },
    languages() {
      return this.$store.state.passport.languages;
    },
  },
  beforeCreate() {
    this.$store.dispatch(HIDE_DIALOG);
  },
  methods: {
    switchByFollowCode() {
      this.$store
        .dispatch(SWTICH_BY_MIGRATE, {
          followCode: this.followCode || '',
          password: this.password || '',
        })
        .then(() => {
          this.$clearDisable();
        })
        .catch(err => {
          this.errTips = err.message;
          this.$clearDisable();
          this.showPopup = true;
        });
    },
  },
  components: {
    Dialog,
  },
};
</script>
